import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 0.5V3.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 0.5V3.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0556 2H2.94444C2.1467 2 1.5 2.6467 1.5 3.44444V12.5C1.5 13.88 2.62 15 4 15H12C13.38 15 14.5 13.88 14.5 12.5V3.44444C14.5 2.6467 13.8533 2 13.0556 2Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 6H14.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		})
	]
});
export default SvgCalendar;
